import PropTypes from 'prop-types'

export default PropTypes.shape({
  formatted: PropTypes.string,
  formattedCompactWithTime: PropTypes.string,
  formattedFullWithTime: PropTypes.string,
  formattedMinimalWithTime: PropTypes.string,
  fromTimestamp: PropTypes.number,
  toTimestamp: PropTypes.number,
})
